module.exports = __webpack_public_path__ + "static/media/atendimento-4.991f1990.png";